// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.card-id-team-selection-modal__content {
    padding: 36px 40px 12px 40px;
}

.card-id-team-selection-modal__title.baloa-table {
    color: var(--primary-very-dark-color);
}

.card-id-team-selection-modal__team {
    display: flex;
    align-items: center;
    padding: 10px 6px;
    border-radius: 6px;
    border: 1px solid var(--new-gray-background-color);
    margin-top: 14px;
    width: 100%;
}

.card-id-team-selection-modal__team-info {
    display: flex;
    align-items: center;
}

.card-id-team-selection-modal__team-image {
    width: 35px;
    height: 35px;
    margin-right: 10px;
}

.card-id-team-selection-modal__team-image .icon-ball{
    color: var( --white-color );
    font-size: 29px;
    border-radius: 50%;
    padding: 3px; 
}

.card-id-team-selection-modal__team-image img{
    width: inherit;
    height: inherit;
    border-radius: 50%;
}

.card-id-team-selection-modal__team-data .baloa-table-column {
    color: var(--primary-very-dark-color);
}

.card-id-team-selection-modal__team-data .baloa-username {
    color: var(--primary-dark-color);
}

.card-id-team-selection-modal__buttons {
    padding: 16px;
    border-top: 1px solid var(--new-gray-background-color);
}

.card-id-team-selection-modal__buttons__download-button {
    margin-left: auto;
}

.card-id-team-selection-modal__buttons__download-button.small {
    padding: 10px 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-card-id-teams-selection-modal/TournamentCardIdTeamsSelectionModalComponent.styles.css"],"names":[],"mappings":";AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,kDAAkD;IAClD,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sDAAsD;AAC1D;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["\n.card-id-team-selection-modal__content {\n    padding: 36px 40px 12px 40px;\n}\n\n.card-id-team-selection-modal__title.baloa-table {\n    color: var(--primary-very-dark-color);\n}\n\n.card-id-team-selection-modal__team {\n    display: flex;\n    align-items: center;\n    padding: 10px 6px;\n    border-radius: 6px;\n    border: 1px solid var(--new-gray-background-color);\n    margin-top: 14px;\n    width: 100%;\n}\n\n.card-id-team-selection-modal__team-info {\n    display: flex;\n    align-items: center;\n}\n\n.card-id-team-selection-modal__team-image {\n    width: 35px;\n    height: 35px;\n    margin-right: 10px;\n}\n\n.card-id-team-selection-modal__team-image .icon-ball{\n    color: var( --white-color );\n    font-size: 29px;\n    border-radius: 50%;\n    padding: 3px; \n}\n\n.card-id-team-selection-modal__team-image img{\n    width: inherit;\n    height: inherit;\n    border-radius: 50%;\n}\n\n.card-id-team-selection-modal__team-data .baloa-table-column {\n    color: var(--primary-very-dark-color);\n}\n\n.card-id-team-selection-modal__team-data .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.card-id-team-selection-modal__buttons {\n    padding: 16px;\n    border-top: 1px solid var(--new-gray-background-color);\n}\n\n.card-id-team-selection-modal__buttons__download-button {\n    margin-left: auto;\n}\n\n.card-id-team-selection-modal__buttons__download-button.small {\n    padding: 10px 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
